// Table.jsx
import React, { useCallback, useEffect, useState } from 'react';
import { useMsal } from '@azure/msal-react';
import { useNavigate } from 'react-router-dom';
import TableHeader from './TableHeader';
import TableRow from './TableRow';
import Pagination from './Pagination';
import ReadyToPublishModal from './ReadyToPublishModal';
import PublishPackageModal from './PublishPackageModal';
import { toast } from 'react-toastify';

const Table = () => {
    const { instance } = useMsal();
    const navigate = useNavigate();
    const [tableData, setTableData] = useState([]);
    const [filters, setFilters] = useState({ ComponentName: '', Technology: '', Category: '', ComponentState: '' });
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [selectedRow, setSelectedRow] = useState(null);
    const [openLinkModal, setOpenLinkModal] = useState(false);
    const [openPackageModal, setOpenPackageModal] = useState(false);
    const [loading, setLoading] = useState(true); // New loading state

    const fetchTableData = useCallback(async () => {
        setLoading(true);
        try {
            const email = instance.getAllAccounts()?.[0]?.username.toLowerCase();
            const res = await fetch("https://prod.appstudioltts.com/api/linkstateupdate/fetchdata");
            const data = await res.json();
            const userData = data.filter(item => 
  item?.Email?.toLowerCase() === email
);
console.log("All emails:", data.map(d => d.Email));
console.log("Looking for:", email);

            setTableData(userData);
        } catch (err) {
            console.error("Error fetching data", err);
        } finally {
            setLoading(false);
        }
    }, [instance]);

    useEffect(() => {
        fetchTableData();
    }, [fetchTableData]);

    const filteredData = tableData.filter(item => (
        (!filters.ComponentName || item.ComponentName === filters.ComponentName) &&
        (!filters.Technology || item.Technology === filters.Technology) &&
        (!filters.Category || item.Category === filters.Category) &&
        (!filters.ComponentState || item.ComponentState === filters.ComponentState)
    ));

    const totalPages = Math.ceil(filteredData.length / pageSize);
    const paginatedData = filteredData.slice((currentPage - 1) * pageSize, currentPage * pageSize);

    const handleFilterChange = (key, value) => {
        setFilters(prev => ({ ...prev, [key]: value }));
        setCurrentPage(1);
    };

    const handleReadyToPublishSubmit = async (formData) => {
        try {
            const response = await fetch(
                `https://prod.appstudioltts.com/api/linkstateupdate/updatedata/${selectedRow._id}`,
                {
                    method: 'PUT',
                    body: formData,
                }
            );

            if (response.ok) {
                toast.success('Component submitted successfully!');
                setOpenLinkModal(false);
                fetchTableData(); // refresh table
            } else {
                toast.error('Failed to submit data');
            }
        } catch (error) {
            console.error('Submission error:', error);
            toast.error('Error submitting data');
        }
    };

    const openContributor = () => navigate('/dashboard/ui_repo');

    return (
        <div className="pt-4">
            <div className="h-[45vh] border border-gray-300 rounded-md overflow-x-auto">
                <table className="min-w-full text-sm text-left bg-white">
                    <TableHeader data={tableData} filters={filters} onFilterChange={handleFilterChange} />
                    <tbody>
                        {loading ? (
                            <tr>
                                <td colSpan="7" className="text-center px-4 py-6">
                                    <div className="flex justify-center items-center space-x-2">
                                        <div className="w-5 h-5 border-2 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
                                        <span className="text-blue-600 text-sm">Loading...</span>
                                    </div>
                                </td>

                            </tr>
                        ) : paginatedData.length > 0 ? (
                            paginatedData.map((row, idx) => (
                                <TableRow
                                    key={row._id}
                                    row={row}
                                    index={(currentPage - 1) * pageSize + idx}
                                    refresh={fetchTableData}
                                    setSelectedRow={setSelectedRow}
                                    setOpenLinkModal={setOpenLinkModal}
                                    setOpenPackageModal={setOpenPackageModal}
                                />
                            ))
                        ) : (
                            <tr>
                                <td colSpan="7" className="text-center px-4 py-6">
                                    No Data Found
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>

            <Pagination
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                totalPages={totalPages}
                setPageSize={setPageSize}
            />

            <div className="flex justify-end mt-2">
                <button className="p-2 px-4 border border-blue-600 text-blue-600 text-sm rounded-md" onClick={openContributor}>
                    Close
                </button>
            </div>

            {/* Modals */}
            {openLinkModal && (
                <ReadyToPublishModal
                    row={selectedRow}
                    onClose={() => setOpenLinkModal(false)}
                    onSubmit={handleReadyToPublishSubmit}
                    refresh={fetchTableData}
                    selectedRowData={selectedRow}
                />
            )}
            {openPackageModal && (
                <PublishPackageModal
                    row={selectedRow}
                    onClose={() => setOpenPackageModal(false)}
                    refresh={fetchTableData}
                />
            )}
        </div>
    );
};

export default Table;